import { createContext, useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import store from "store";
import { LANGUAGE_STORAGE_KEY, translateText } from "locales/translations";

const LocaleContext = createContext({
  locale: "en",
  setLocale: () => {},
  t: (text) => text,
});

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(store.get(LANGUAGE_STORAGE_KEY) || "en");

  useEffect(() => {
    store.set(LANGUAGE_STORAGE_KEY, locale);
  }, [locale]);

  const value = useMemo(
    () => ({
      locale,
      setLocale: setLocaleState,
      t: (text) => translateText(text, locale),
    }),
    [locale]
  );

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

LocaleProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useLocale = () => useContext(LocaleContext);
